"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var d = Object.defineProperty;

var e = function e(c, a) {
  for (var b in a) {
    d(c, b, {
      get: a[b],
      enumerable: !0
    });
  }
};

exports.a = e;